import React from "react";
const Image = ({className,style, src, alt}) => {
    const imagePath = `${process.env.REACT_APP_API_BASE_URL}/${src}`;
    return (
        <img
            src={imagePath}
            alt={alt}
            className={className}
            style={style}
        />
    );
}
export default React.memo(Image);
